import { createBrowserHistory as createHistory } from 'history'

const history = createHistory()
history.listen((location, action) => {
  if (location.pathname !== '/' && !location.pathname.includes('auth')) {
    const showModal = window.sessionStorage.getItem('showModal') === 'true'
    if (showModal) window.location.href = '/'
  }

  window.scrollTo(0, 0)
})

export default history



// WEBPACK FOOTER //
// ./src/redux/history.js